import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { scrollToElement } from "../../../util/viewport-utils";
import PropTypes from "prop-types";
import { AlphaTabs, AlphaTab } from "discover.medical.react-component-library";

const getActiveTabIndex = (tabs) => {
  for (let i = 0; i < tabs.length; i++) {
    if (tabs[i].isActive) {
      return i;
    }
  }
};

const TabsHeader = ({ itemsList, StickyWrapperId, RootElement }) => {
  const [tabsList, setTabsList] = useState(itemsList);

  const history = useHistory();
  const {
    location: { hash },
  } = history;

  useEffect(() => {
    setTabsList(itemsList);
  }, [itemsList]);

  const diseaseConditionsElement = document.getElementById(RootElement);
  const hashId = hash.substring(1); //The first character # needs removed
  const idElement = document.getElementById(hashId);

  useEffect(() => {
    if (!!diseaseConditionsElement && !!idElement) {
      const distance = diseaseConditionsElement.getBoundingClientRect().top;
      const scrollOffset = distance >= 0 ? distance : 0;
      scrollToElement(hashId, StickyWrapperId, scrollOffset);
    }
    // set active tab based on hash
    if (hashId) {
      // Only update the active tab if the hash is different than the current active tab to avoid infinite loop
      const currentActiveIndex = getActiveTabIndex(tabsList);
      const newActiveIndex = tabsList.findIndex((tab) => tab.id === hashId);
      if (newActiveIndex !== -1 && newActiveIndex !== currentActiveIndex) {
        setActiveTab(tabsList, newActiveIndex);
      }
    }
  }, [diseaseConditionsElement, idElement, hashId, StickyWrapperId, tabsList]);

  const setActiveTab = (tabs, activeIndex) => {
    setTabsList(
      tabs.map((tab, index) => ({
        ...tab,
        isActive: index === activeIndex,
      }))
    );
  };

  const handleTabChange = (e, index) => {
    const path = `${history.location.pathname}${
      history.location.search || ""
    }#${tabsList[index].id}`;
    history.push(path);
    setActiveTab(tabsList, index);
  };

  return (
    <AlphaTabs
      scrollButtons={true}
      data-testid="tabsHeader"
      activeTab={getActiveTabIndex(tabsList)}
      onChange={handleTabChange}
    >
      {tabsList.map((item) => (
        <AlphaTab key={item.char} data-testid={`tabsHeader-${item.char}`}>
          {item.char}
        </AlphaTab>
      ))}
    </AlphaTabs>
  );
};

TabsHeader.defaultProps = {
  itemsList: [],
};

TabsHeader.prototypes = {
  itemsList: PropTypes.arrayOf(
    PropTypes.shape({
      char: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      isActive: PropTypes.bool.isRequired,
    })
  ).isRequired,
  StickyWrapperId: PropTypes.string.isRequired,
  RootElement: PropTypes.string.isRequired,
};

export default TabsHeader;
